export default {
    imprimirSolicitacao: state => state.redeSIM.imprimirSolicitacao
  };
  